import $t from 'i18n'

export const validateDOB = (ageRequirments, date, relation) => {
  if (new Date(date) > new Date()) {
    return { isValid: false, error: $t('errors.validation.futureDob') }
  }
  if (!isDateValid(date)) {
    return { isValid: false, error: $t('errors.validation.invalidDob') }
  }
  if (
    (relation === 'owner' || relation === 'spouse') &&
    !isaAgeRequirmentsMet(ageRequirments.adult)(date)
  ) {
    return { isValid: false, error: $t('errors.validation.adultInvalidDob') }
  }
  if (
    relation === 'dependent' &&
    !isaAgeRequirmentsMet(ageRequirments.dependent)(date)
  ) {
    return {
      isValid: false,
      error: $t('errors.validation.dependentInvalidDob')
    }
  }

  return { isValid: true }
}

export const isDateValid = date => {
  let currentYear = new Date().getFullYear()
  let year = new Date(date).getFullYear()
  if (!date || year.toString().length < 4 || year > currentYear) {
    return false
  }
  return true
}

const isaAgeRequirmentsMet =
  ({ min = 0, max = Number.MAX_SAFE_INTEGER }) =>
  dob => {
    let currentDate = new Date()
    let birthDate = new Date(dob)

    // Calculate the age
    let age = currentDate.getFullYear() - birthDate.getFullYear()

    // Adjust the age if the birth date hasn't occurred yet this year
    if (
      currentDate.getMonth() < birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() &&
        currentDate.getDate() < birthDate.getDate())
    ) {
      age--
    }

    // Check if the age is within the min and max limits
    return age >= min && age <= max
  }
